<template>
  <div>
    <horizontal-field-layout
      class="mt-8"
      label="Sponsored Products"
      label-field-ratio="3/7"
    >
      <select-field
        v-model="innerAdSpCvType"
        :disabled="readOnly"
        name="Sponsored Products"
        rules="required"
        :options="adSpCvTypeOptions"
        full-width
      />
    </horizontal-field-layout>
    <horizontal-field-layout
      class="mt-8"
      label="Sponsored Brands"
      label-field-ratio="3/7"
    >
      <select-field
        v-model="innerAdSbCvType"
        :disabled="readOnly"
        name="Sponsored Brands"
        rules="required"
        :options="adSbCvTypeOptions"
        full-width
      />
    </horizontal-field-layout>
    <horizontal-field-layout
      class="mt-8"
      label="Sponsored Display"
      label-field-ratio="3/7"
    >
      <select-field
        v-model="innerAdSdCvType"
        :disabled="readOnly"
        name="Sponsored Display"
        rules="required"
        :options="adSdCvTypeOptions"
        full-width
      />
    </horizontal-field-layout>
  </div>
</template>

<script>
import SelectField from '@/components/fields/SelectField'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'

export default {
  name: 'AdCvForm',
  components: {
    HorizontalFieldLayout,
    SelectField
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    adSdCvType: {
      type: Number,
      default: 1
    },
    adSpCvType: {
      type: Number,
      default: 1
    },
    adSbCvType: {
      type: Number,
      default: 1
    }
  },
  emits: [
    'update:ad-sd-cv-type',
    'update:ad-sp-cv-type',
    'update:ad-sb-cv-type'
  ],
  computed: {
    innerAdSdCvType: {
      get () {
        return this.adSdCvType
      },
      set (value) {
        this.$emit('update:ad-sd-cv-type', value)
      }
    },
    adSdCvTypeOptions () {
      return [
        { value: 3, text: '広告クリック後14日以内の合計CV（Amazon 管理画面と同定義）' },
        { value: 7, text: '広告クリック後14日以内の宣伝ASINのCV' }
      ]
    },
    innerAdSpCvType: {
      get () {
        return this.adSpCvType
      },
      set (value) {
        this.$emit('update:ad-sp-cv-type', value)
      }
    },
    adSpCvTypeOptions () {
      return [
        { value: 1, text: '広告クリック後1日以内の合計CV' },
        { value: 2, text: '広告クリック後7日以内の合計CV（Amazon 管理画面と同定義）' },
        { value: 3, text: '広告クリック後14日以内の合計CV' },
        { value: 4, text: '広告クリック後30日以内の合計CV' },
        { value: 5, text: '広告クリック後1日以内の宣伝ASINのCV' },
        { value: 6, text: '広告クリック後7日以内の宣伝ASINのCV' },
        { value: 7, text: '広告クリック後14日以内の宣伝ASINのCV' },
        { value: 8, text: '広告クリック後30日以内の宣伝ASINのCV' }
      ]
    },
    innerAdSbCvType: {
      get () {
        return this.adSbCvType
      },
      set (value) {
        this.$emit('update:ad-sb-cv-type', value)
      }
    },
    adSbCvTypeOptions () {
      return [
        { value: 1, text: '広告クリック後14日以内の合計CV（Amazon 管理画面と同定義）' },
        { value: 2, text: '広告クリック後14日以内の宣伝ASINのCV' }
      ]
    }
  }
}
</script>

<style>
</style>
